import { BrandKey } from './brand';

/**
 * Banner on the PayUp vendor host. Copy matches payup-api rebrandNotice.ts
 * (Tiffany Zucarelli, 2026-09-25). BillRoute Pay hosts stay quiet.
 *
 * Windows are America/Chicago midnights:
 * - before 2026-10-01: full name-change banner
 * - 2026-10-01 through 2026-11-30: short bridge line
 */

const CUTOVER = new Date('2026-10-01T05:00:00.000Z');
const BRIDGE_END = new Date('2026-12-01T06:00:00.000Z');

export const REBRAND_BANNER_BEFORE =
  'We\'re getting a new name! Starting October 1, PayUp will become BillRoute Pay. This is a rebrand only. Your account, login, payment details, and payment schedule all stay the same, and there\'s nothing you need to do. You will see "BillRoute Pay" on payment notifications starting October 1.';

export const REBRAND_BANNER_AFTER =
  'BillRoute Pay, formerly PayUp. Same account, same payments, new name.';

export const REBRAND_PORTAL_URL = 'https://pay.billroute.com';

export const rebrandBannerCopy = (now: Date, brandKey: BrandKey): string | null => {
  if (brandKey !== 'payup') return null;
  if (now < CUTOVER) return REBRAND_BANNER_BEFORE;
  if (now < BRIDGE_END) return REBRAND_BANNER_AFTER;
  return null;
};
